/**
 * Telling a note somebody wrote apart from a note the importer wrote.
 *
 * `customers.notes` holds both. The Loyverse import put a line of provenance
 * on almost every record it created — "Loyverse history: 5 visits, ₱6,330.00"
 * — so on the shop's database 299 of the 322 notes are entirely that, and
 * nothing else. A card that showed the field whole would show import chatter
 * on nearly every client, and the twenty-odd real notes would read as more of
 * the same.
 *
 * Those are the ones that matter: "10% discount for 1 next order", "request to
 * meet the rider on his way". They are standing instructions about a person,
 * and the counter has to see them without hunting.
 *
 * Nothing is dropped. The provenance is still returned, to be shown quietly
 * beside what a person actually wrote.
 */
/**
 * Lines this app generated during the Loyverse import.
 *
 * Matched on the exact prefixes the import scripts write, not on anything a
 * person is likely to type. Both live in `scripts/import-loyverse`.
 */
const IMPORTED = [/^Loyverse history:/i, /^Added from a Loyverse receipt\b/i];
export function splitCustomerNotes(notes) {
    const lines = (notes ?? '')
        .split('\n')
        .map((line) => line.trim())
        .filter(Boolean);
    const imported = (line) => IMPORTED.some((pattern) => pattern.test(line));
    return {
        note: lines.filter((line) => !imported(line)).join('\n'),
        provenance: lines.filter(imported).join('\n'),
    };
}
//# sourceMappingURL=customer-notes.js.map